import { Challenge } from '@wix/ambassador-challenges-v1-challenge/types';

export const isSpecific = (challenge: Challenge): boolean =>
  Boolean(challenge?.settings?.timelineType?.specific?.duration);
